import Joi from "joi";

const ConsultationFormSchema = Joi.object({
  unit: Joi.string().trim().required().messages({
    "any.required": "Unit is required.",
    "string.empty": "Unit is required.",
  }),
  doctor: Joi.string().trim().required().messages({
    "any.required": "Doctor is required.",
    "string.empty": "Doctor is required.",
  }),
  visitType: Joi.string().trim().required().messages({
    "any.required": "Visit Type is required.",
    "string.empty": "Visit Type is required.",
  }),
  consultationDateTime: Joi.date().iso().required().messages({
    "any.required": "Consultation Date and Time is required.",
    "date.format": "Consultation Date and Time must be a valid ISO date.",
    "date.base": "Consultation Date and Time must be a valid date.",
  }),
  consultationCharge: Joi.number().min(0).required().messages({
    "any.required": "Amount is required.",
    "number.base": "Amount must be a number.",
    "number.min": "Amount must be 0 or greater.",
  }),
  payment: Joi.object({
    transactionId: Joi.string().allow(null).messages({
      "string.base": "Transaction ID must be a string.",
    }),
    transactionType: Joi.string().required().messages({
      "any.required": "Transaction Type is required.",
      "string.empty": "Transaction Type is required.",
    }),
    amountPaid: Joi.number().min(0).required().messages({
      "number.min": "Amount Paid must be 0 or greater.",
      "any.required": "Amount Paid is required.",
      "number.base": "Amount Paid must be a number.",
    }),
    remarks: Joi.string().allow('').optional().messages({
      "string.base": "Remarks must be a string."
    }),
    paymentType: Joi.string().required().messages({
      "any.required": "Payment Type is required.",
      "string.empty": "Payment Type is required.",
    }),
  }).optional().messages({
    "any.required": "Payment details are required.",
  }),
}).unknown(true);

export default ConsultationFormSchema;

export const IPDSchema = Joi.object({
  payment: Joi.object({
    transactionType: Joi.string().required(),
    transactionId: Joi.string().allow(null),
    amountPaid: Joi.number().min(0).required(),
    remarks: Joi.string().allow('').optional(),
    paymentType: Joi.string().valid('SelfPayment', 'Insurance', 'Corporate', 'InvoicePayment').required()
  }).required(),

  bedOccupancy: Joi.object({
    ward: Joi.string().required(),
    bed: Joi.string().required()
  }).required(),

  emergencyContact: Joi.object({
    name: Joi.string().required(),
    relationship: Joi.string().required(),
    contactNumber: Joi.string()
      .pattern(/^[0-9]{10}$/)
      .message('contactNumber must be a valid 10-digit number')
      .required()
  }).required(), 

  doctor: Joi.string().required(),
  unit: Joi.string().required(),
}).unknown(true);

export const OutsiderSchema = Joi.object({
  payment: Joi.object({
    transactionType: Joi.string().required(),
    transactionId: Joi.string().allow(null),
    amountPaid: Joi.number().min(0).required(),
    remarks: Joi.string().allow('').optional(),
    paymentType: Joi.string().valid('SelfPayment', 'Insurance', 'Corporate', 'InvoicePayment').required()
  }).required(),

  services: Joi.array().items(
    Joi.object({
      category: Joi.string().required(),
      item: Joi.string().required(),
      quantity: Joi.number().min(1).required(),
      assignedDoctor: Joi.string().allow(null).optional()
    }).unknown(true)
  ).min(1).required()
}).unknown(true);
